export const MIN_SPACER_SIZE = 0;
